import React, { FunctionComponent, memo } from 'react';
import { Box, Grid } from '@material-ui/core';
import ColorOption from '../../../../../../../../../gqlCommon/components/colorOption/ColorOption';
import useScrollToSection from '../../../../../../../../hooks/navigation/useScrollToSection';
import IExtendedFeaturesList from '../../../../../../../../model/IExtendedFeaturesList';
import summaryStyles from '../../../../../summary/summarySection/SummaryStyles';
import SelectedOptionTitle from '../../../../customiseOptions/customiseOptionTitle/ColorOptionTitle';
import SelectedFeaturePrice from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeaturePrice/SelectedFeaturePrice';
import SelectedSectionName from '../selectedSectionName/SelectedSectionName';
import ChangeSelectedOptionLink from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeatureAction/ChangeSelectedOptionLink';

export interface ISelectedColorOptionsProps {
  featuresList: IExtendedFeaturesList;
  sectionName: string;
}

const SelectedColorOption: FunctionComponent<ISelectedColorOptionsProps> = memo(({ featuresList, sectionName }) => {
  const { scrollToSection } = useScrollToSection();
  const styles = summaryStyles();

  return (
    <>
      {featuresList?.features?.map((feature, index) => (
        <Box key={index} className={styles.selectionContainer}>
          <SelectedSectionName label={sectionName} />
          <Box mx={1} my={1} data-test={`option:${feature.code}`}>
            <ColorOption
              id={feature.code}
              feature={feature}
              selectedCode={feature.code}
              isDisabled={false}
              variant={'small'}
            />
          </Box>
          <Grid container={true} direction="row" justifyContent="space-between" alignContent="flex-end">
            <SelectedOptionTitle
              title={feature.name}
              price={feature.prices[0].money}
              isSummary={true}
              featureId={feature.code}
            />
            <SelectedFeaturePrice feature={feature} />
          </Grid>
          <ChangeSelectedOptionLink onClick={() => scrollToSection(sectionName)} />
        </Box>
      ))}
    </>
  );
});

export default SelectedColorOption;
